module.exports = __webpack_public_path__ + "assets/img/mosaic-columns-3.5f380af3.jpg";